import '../ranking_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.HashtagRankingChartView extends Monitoring.Views.Charts.RankingChartView
  template: JST["backbone/templates/monitoring/charts/hashtag_ranking"]
  className: 'chart-ranking item w1 h3'
  tabs: 1

  initialize: (@options = {}) ->
    @filename = 'hashtag_ranking.png'
    super

  render: ->
    ranking =
      id: 'hashtag_ranking_chart'
      title: I18n.t('monitoring.dashboard.charts.hashtag_ranking')
      field: 'hashtags'
      spanSize: '12'
      longNumber: true
    @$el.html(@generic_template rankings: [ranking], results: @defaultResults)
    @getHashtags ranking, @template
    @
